"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.saveLocalData = saveLocalData;
exports.getLocalData = getLocalData;
exports.removeLocalData = removeLocalData;

function saveLocalData(key, data) {
  var _global;

  if (!key || !((_global = global) !== null && _global !== void 0 && _global.localStorage)) return;
  data = JSON.stringify(data);
  localStorage.setItem(key, data);
}

function getLocalData(key) {
  var _global2;

  if (!key || !((_global2 = global) !== null && _global2 !== void 0 && _global2.localStorage)) return;
  var data = localStorage.getItem(key);
  if (!data) return data;
  return JSON.parse(data);
}

function removeLocalData(key) {
  var _global3;

  if (!key || !((_global3 = global) !== null && _global3 !== void 0 && _global3.localStorage)) return;
  localStorage.removeItem(key);
}